import {
  Directive,
  ElementRef,
  AfterViewInit,
  Renderer2,
  Input
} from '@angular/core';

@Directive({
  selector: '[hostPlaceholder]'

})
export class PlaceholderDirective implements AfterViewInit {
  @Input()
  set delaySrc(value) {
    this._delaySrc = value;
    if (value) {
      this.loadImage();
    }
  }
  _delaySrc;
  element: HTMLImageElement;

  constructor(private el: ElementRef, private render: Renderer2) { }

  ngAfterViewInit() {
    this.element = this.el.nativeElement;
    this.loadImage();
  }

  loadImage() {
    const imgUrl = this._delaySrc || this.element.dataset.src;
    const img = new Image();
    img.src = imgUrl;
    img.onload = () => {
      this.render.setAttribute(this.element, 'src', imgUrl);
    };
  }
}
